<script>
	import { LoginStates, StateMessages } from './lib';
	export let stateMask;
	export let loginState = 0;
	let count, interval;
	const stateIcons = {}
	stateIcons[LoginStates.IDLE] = 'loading'
	stateIcons[LoginStates.SUCCESS] = 'check'
	stateIcons[LoginStates.ERROR] = 'clear'

	function processState(loginState){
		if(loginState == LoginStates.COUNTING) {
			count = 2;
			interval = setInterval(() => {
				count = count - 1;
			}, 1100)
		}else{
			clearInterval(interval)
		}
	}

	$: processState(loginState)
</script>

<div class="Ticker" class:hide={loginState === LoginStates.SUCCESS}>
{#if stateMask}
	{StateMessages[stateMask]}
{:else if loginState == LoginStates.COUNTING}
	<span class="count">{count}...</span>
{:else}
	<span class="spinner" data-icon={stateIcons[loginState]}></span>
{/if}
</div>

<style>
.Ticker {
	position: absolute;
	z-index: 2;
	left: 50%;
	transform: translateX(-50%);
	bottom: 10%;
	background: rgba(0,0,0,0.5);
	min-width: 3em;
	min-height: 3em;
	max-width: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0.7em 1em;
	box-sizing: border-box;
	border-radius: 4px;
	margin-left: 0.7em;
	opacity: 1;
	transition: 0.2s opacity 0.4s ease;
	font-size: 1.4em;
}
.spinner {
	font-size: 27px;
	line-height: 0;
}
.hide {
	opacity: 0;
}
</style>